import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import * as _ from "lodash";

declare var $: any;

@Component({
  selector: 'ing-data-list',
  templateUrl: './data-list.component.html',
  styleUrls: ['./data-list.component.scss']
})
export class DataListComponent implements OnInit {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() newItemText: string;
  @Input() dataLst: Array<any>;
  @Input() fields: Array<any> = [];

  @Input() rowsOnPage: number = 20;
  @Input() sortBy: string;
  @Input() sortOrder: string = 'asc';

  @Output() edit                  = new EventEmitter();
  @Output() create                = new EventEmitter();
  @Output() delete                = new EventEmitter();
  @Output('grid-click') gridClick = new EventEmitter();

  @Input('grid-buttons') gridButtons: Array<{cssClass: string, icon?: string, text?: string, tooltip?: string}> = null;

  filterQuery: any = {};

  constructor() { }

  ngOnInit() {
    $('.loader-inner').loaders();
  }

  ngOnChanges(changes: any) {
    if(!!changes.dataLst && changes.dataLst.currentValue == null) {
      setTimeout(() => {
        $('.loader-inner').loaders();
      });
    }
  }

  onCreate() {
    this.create.next();
  }

  onEdit(item: any) {
    this.edit.next(item);
  }

  onDelete(item: any) {
    this.delete.next(item);
  }

  onGridClick(item) {
    this.gridClick.next(item);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-list/data-list/data-list.component.ts